import * as utils from '../js/utils';
import * as api from '../js/api';


class ResetButton {
    public async reset() {
        try {
            await api.request('/session', {method: 'DELETE'});
            window.location.reload();
        } catch (e) {
            utils.showMessage({form: document, message: utils.getErrorMessage(e)})
        }
    }

    public static bind() {
        document.querySelectorAll('[data-action="reset"]').forEach((element) => {
            const button = new ResetButton();
            element.addEventListener('click', button.reset.bind(this));
        });
    }
}

export default async function () {
    ResetButton.bind();
}